import { APPLICANT_PROFILE_WIDGET_LIST_ORDER } from './RentalPortalApplicantProfileWidgetList.constants'
import { useApplicantProfileWidgets } from './RentalPortalApplicantProfileWidgetList.hooks'
import { getApplicantProfileOrderedWidgets } from './RentalPortalApplicantProfileWidgetList.utils'

function RentalPortalApplicantProfileWidgetList() {
  const { widgets } = useApplicantProfileWidgets()

  return getApplicantProfileOrderedWidgets({
    widgetListOrder: APPLICANT_PROFILE_WIDGET_LIST_ORDER,
    widgets,
  })
}

export default RentalPortalApplicantProfileWidgetList
